// 个人中心
const personalCenter = [
  {
    path: 'center',
    component: resolve => require(['@/components/personal/center/index'], resolve),
    meta: {requireAuth: true},
    children: [
      {
        path: 'home',
        meta: {requireAuth: true},
        component: resolve => require(['@/components/personal/center/home/index'], resolve)
      },
      {
        path: 'resume',
        meta: {requireAuth: true},
        component: resolve => require(['@/components/personal/center/resume/index'], resolve)
      },
      {
        path: 'record',
        meta: {requireAuth: true},
        component: resolve => require(['@/components/personal/center/record/index'], resolve)
      },
      {
        path: 'apply',
        meta: {requireAuth: true},
        component: resolve => require(['@/components/personal/center/apply/index'], resolve)
      },
      {
        path: 'collect',
        meta: {requireAuth: true},
        component: resolve => require(['@/components/personal/center/collect/index'], resolve)
      },
      {
        path: 'message',
        meta: {requireAuth: true},
        component: resolve => require(['@/components/personal/center/message/index'], resolve)
      },
      {
        path: 'shield',
        meta: {requireAuth: true},
        component: resolve => require(['@/components/personal/center/shield/index'], resolve)
      },
      {
        path: 'take',
        meta: {requireAuth: true},
        component: resolve => require(['@/components/personal/center/take/index'], resolve)
      },
      {
        path: 'services',
        meta: {requireAuth: true},
        component: resolve => require(['@/components/personal/center/services/index'], resolve)
      },
      {
        path: 'safe',
        meta: {requireAuth: true},
        component: resolve => require(['@/components/personal/center/safe/index'], resolve)
      }
    ],
    redirect: '/center/home'
  },
  {
    path: '/center/resumeAction',
    name: 'createResume',
    component: resolve => require(['@/components/personal/center/other/resumeAction'], resolve),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/center/resumeSuccess/:id',
    name: 'resumeSuccess',
    component: resolve => require(['@/components/personal/center/other/resumeSuccess'], resolve),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/center/resumeDetail/:id',
    name: 'resumeDetail',
    component: resolve => require(['@/components/personal/center/other/resumeDetail'], resolve),
    meta: {
      requireAuth: true
    }
  },
  {
    path: '/center/resumeDownload/:id',
    name: 'resumeDownload',
    component: resolve => require(['@/components/personal/center/other/resumeDownload'], resolve),
    meta: {
      requireAuth: true
    }
  }
]

// 职位管理
const personalPosition = [
  {
    path: 'position',
    meta: {requireAuth: true},
    component: resolve => require(['@/components/personal/position/index'], resolve)
  },
  {
    path: '/position/details/:id/company',
    name: 'companyDetails',
    component: resolve => require(['@/components/personal/position/details/company'], resolve)
  },
  {
    path: '/position/details/:id/position',
    name: 'positionDetails',
    component: resolve => require(['@/components/personal/position/details/position'], resolve)
  }
]

// 招聘会
const jobFair = [
  {
    path: 'jobFair',
    meta: {requireAuth: true, bgColor: '#f2f6fc'},
    component: resolve => require(['@/components/personal/jobFair/index'], resolve)
  },
  {
    path: '/jobFair/:id/details',
    meta: {requireAuth: true, bgColor: '#f2f6fc'},
    name: 'jobFairDetails',
    component: resolve => require(['@/components/personal/jobFair/details'], resolve)
  },
  {
    path: '/jobFair/details/:id/company',
    name: 'fairCompanyDetails',
    component: resolve => require(['@/components/personal/jobFair/details/company'], resolve)
  },
  {
    path: '/jobFair/details/:id/position',
    name: 'fairPositionDetails',
    component: resolve => require(['@/components/personal/jobFair/details/position'], resolve)
  }
]

// 错误页面
const error = [
  {
    path: 'error',
    component: resolve => require(['@/components/personal/error/index'], resolve)
  }
]

export default [
  {
    path: '/',
    component: resolve => require(['@/components/personal/index'], resolve),
    children: [
      ...jobFair,
      ...personalPosition,
      ...personalCenter,
      ...error
    ],
    redirect: '/center'
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/personal.js